import { getUsersState } from '../selectors';

export const getUserDetailsState = state => getUsersState(state).details;
export const getUserDetails = state => getUserDetailsState(state).data;
